// extracted by mini-css-extract-plugin
export default {"recovery":"Recovery_recovery__sFJWo"};